import React from "react";
import { Link, useParams } from "react-router-dom";
import "../style/Product.css";
import"../style/ProductDetails.css";

import MasterData from "../Data/masterData";

const ProductSubcategory = () => {
  const { category, type } = useParams();

  const result = MasterData?.[category].subCategories.find((item) => item.id === type);

  if (!result) {
    return (
      <div className="product-details not-found">
        <h2>⚠ Product List not found</h2>
        <Link to={`/product/${category}`}>⬅ Back to Products</Link>
      </div>
    );
  }

  return (
    <div className="product-page">
      <h1>{result.name}</h1>
      <div className="product-grid">
        {result.list.map((motor) => (
          <div key={motor.id} className="product-card">
            <img src={motor.img} alt={motor.name} />
            <h3>{motor.name}</h3>
            <p>{motor.description}</p>
            <Link to={`/product/${category}/${type}/${motor.id}`}
              className="product-btn">
                
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSubcategory;